import { xScreen } from "@guestsupply/XDL/Utilities";
import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import { productImageStyles } from "@insite/content-library/Widgets/ProductList/ProductListProductImage";
import { StyledButton } from "@insite/mobius/Clickable";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { css } from "styled-components";

productImageStyles.wrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        width: 100%;
        ${xScreen("gte", "md")} {
            &&& > ${StyledButton} {
                ${({ isGridView }: any) => isGridView && "max-width: 300px;height: 300px; justify-content: center;"}
            }
        }
    `,
};
productImageStyles.compareCheckbox = {
    css: css`
        align-self: center;
        padding-top: 20px;
    `,
};
productImageStyles.productImage = {
    image: {
        css: css`
            img {
                min-width: 100%;
            }
            position: absolute;
            top: 0;
            left: 0;
            z-index: 0;
        `,
    },
};
productImageStyles.badgeAreaWrapper = {
    css: css`
        position: relative;
    `,
};
productImageStyles.badgeTextWrapper = {
    css: css`
        position: absolute;
        width: 50%;
        white-space: nowrap;
        overflow: hidden;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    css`
                        width: 75%;
                    `,
                ],
                "max",
            )}
    `,
};
productImageStyles.badgeImageWrapper = {
    css: css`
        position: absolute;
        width: 25%;
        height: 25%;
    `,
};
productImageStyles.badgeText = {
    weight: "bold",
    css: css`
        width: 100%;
        margin: auto;
        ${wrapInContainerStyles}
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    css`
                        font-size: 10px;
                    `,
                ],
                "max",
            )}
    `,
};

productImageStyles.compareCheckbox = {
    css: css`
        align-self: center;
    `,
};
